export default __webpack_public_path__ + "static/media/88b59eb6a74ed14f2a46209eca5957e11602868821335.1fbefda2.webp";